module.exports = "../static/media/official.5e3ea4df.png";